import { render, staticRenderFns } from "./Document-Signed.vue?vue&type=template&id=dd24e578"
import script from "./Document-Signed.vue?vue&type=script&lang=js"
export * from "./Document-Signed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports